import React, { useEffect } from 'react';

import { Card, TableHead, TableBody, Table } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { StyledTableRow, StyledTableCell, HeaderTableCell } from 'screens/Team/TeamTasksListView/styles';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import NewEditableTagRow, { StyledHorizontalLine, StyledVerticalLine } from './NewEditableTagRow';
import { SkeletonContainer } from './styles';
import useTableState from './useTableState';

const getLeftPadding = (nestingLevel) => {
  const paddingFactor = 30;
  return `${nestingLevel * paddingFactor}px`;
};

const getVerticalLines = (nestingLevel) => {
  if (nestingLevel === 0) return null;

  return (
    <>
      {Array.from(Array(nestingLevel - 1).keys()).map((num) => (
        <StyledVerticalLine left={`${(num + 1) * -30}px`} />
      ))}
      <StyledVerticalLine bottom="50%" />
      <StyledHorizontalLine width="20px" />
    </>
  );
};

const ExpandedTableWithinCard = ({
  parentTag,
  enableParentExpansion,
  disableParentExpansion,
  nestingLevel = 1,
  showExpandedCard,
}) => {
  const {
    tags,
    loading,
    newTag,
    showTagCreationRow,
    getAllTags,
    updateTag,
    createNewTag,
    enableTagEditing,
    disableEditingForAllTags,
    handleToggleActive,
    displayNewTagCreationRow,
    hideNewTagCreationRow,
    toggleTagEditing,
    disableExpansion,
    enableExpansion,
  } = useTableState({
    parentTag,
    enableParentExpansion,
  });

  // const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    if (showExpandedCard)
      getAllTags((tags) => {
        // if( tags.length === 0 )
        // disableParentExpansion();
      });
  }, [showExpandedCard]);

  return (
    <StyledTableRow>
      <StyledTableCell border-bottom="none" padding="none" colSpan={5}>
        <StyledCard bgColor="#f8fafb">
          {loading ? (
            <SkeletonContainer>
              <Skeleton width="50%" />
              <Skeleton width="40%" />
            </SkeletonContainer>
          ) : (
            <Table>
              <TableHead>
                {/* <HeaderTableCell padding='0' width='10%'></HeaderTableCell> */}
                {/* <HeaderTableCell padding='0' width="10%"></HeaderTableCell> */}
                <HeaderTableCell padding="0" width="40%" />
                <HeaderTableCell padding="0" width="50%" />
                <HeaderTableCell padding="0" width="10%" />
              </TableHead>
              <TableBody>
                {showExpandedCard &&
                  tags.map((tag) => (
                    <NewEditableTagRow
                      key={tag.id}
                      isEditing={tag.isEditing}
                      toggleEditing={toggleTagEditing}
                      onActiveToggle={handleToggleActive}
                      onUpdate={updateTag}
                      tag={tag}
                      isExpandable
                      nestingLevel={nestingLevel}
                      hasChildTags={tag.hasChildTags}
                      canHaveChildTags
                      disableExpansion={() => disableExpansion(tag.id)}
                      enableExpansion={() => enableExpansion(tag.id)}
                    />
                  ))}
                {showTagCreationRow ? (
                  <NewEditableTagRow
                    tag={newTag}
                    onCancel={hideNewTagCreationRow}
                    onUpdate={createNewTag}
                    isExpandable
                    isEditing
                    toggleEditing={toggleTagEditing}
                    nestingLevel={nestingLevel}
                    hasChildTags={false}
                    canHaveChildTags={false}
                  />
                ) : (
                  <StyledTableRow>
                    <StyledTableCell
                      paddingtop="0"
                      paddingBottom="0"
                      paddingLeft={getLeftPadding(nestingLevel)}
                      colSpan={3}
                      border
                    >
                      <StyledCellContainer>
                        {getVerticalLines(nestingLevel)}
                        <StyledTypography2 color="primary" onClick={displayNewTagCreationRow}>
                          + Create sub objective
                        </StyledTypography2>
                      </StyledCellContainer>
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          )}
        </StyledCard>
      </StyledTableCell>
    </StyledTableRow>
  );
};

const StyledCard = styled(Card)`
  width: 100%;
  background-color: ${(props) => props.bgColor};
  box-shadow: none;
  overflow: visible;
  table thead th {
    border-bottom: 0;
  }
`;

const StyledCellContainer = styled.div`
  padding-left: 40px;
  position: relative;
`;

const StyledTypography2 = styled(StyledTypography)`
  line-height: 3;
  font-size: 0.875rem;
  font-weight: bold;
`;

export default ExpandedTableWithinCard;
